import React from "react"

export default function Attribution() {
  return (
    <p className="attribution">
      Adapted from the{" "}
      <a
        href="https://github.com/basecamp/policies"
        rel="noreferrer"
        target="_blank"
      >
        Basecamp open-source policies
      </a>{" "}
      /{" "}
      <a
        href="https://creativecommons.org/licenses/by/4.0/"
        rel="noreferrer"
        target="_blank"
      >
        CC BY 4.0
      </a>
    </p>
  )
}
